import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=12ddda31&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=12ddda31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ddda31",
  null
  
)

export default component.exports